import { getAllCompanies } from "@/api/ppanalytic.api";

const fn = {
  SET_COMPANY: "SET_COMPANY",
  RESET: "RESET"
};

const initialState = () => ({
  companies: []
});

const state = initialState();

// getters
const getters = {
  getCompanies: state => state.companies
};

// actions
const actions = {
  reset({ commit }) {
    commit(fn.RESET);
  },
  async getCompany({ commit }) {
    try {
      let resp = await getAllCompanies();
      commit(fn.SET_COMPANY, resp.data.companies);
    } catch (err) {
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  }
};

// mutations
const mutations = {
  [fn.SET_COMPANY](state, payload) {
    state.companies = payload;
  },
  [fn.RESET](state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
